import { render, staticRenderFns } from "./ConciergeList.vue?vue&type=template&id=bad7b734&scoped=true"
import script from "./ConciergeList.ts?vue&type=script&lang=ts&external"
export * from "./ConciergeList.ts?vue&type=script&lang=ts&external"
import style0 from "./ConciergeList.vue?vue&type=style&index=0&id=bad7b734&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad7b734",
  null
  
)

export default component.exports